import { z } from 'zod';

/**
 * What a player says about their age. It is a band, not a birth date: the rules only need to know
 * whether the free chat may be on (GDD §16.24; in Italy the age of digital consent is 14), and a
 * service that keeps less of a child's data has less to answer for.
 */

export const AGE_GROUPS = ['under_14', '14_to_17', '18_plus'] as const;
export const AgeGroupSchema = z.enum(AGE_GROUPS);
export type AgeGroup = z.infer<typeof AgeGroupSchema>;

/** Position in the order the database keeps (younger first): a declaration may only go down. */
export function ageRank(group: AgeGroup): number {
  return AGE_GROUPS.indexOf(group);
}

/** True when `next` may replace `current`: the first declaration, or the same or a younger band. */
export function mayDeclare(current: AgeGroup | null, next: AgeGroup): boolean {
  return current === null || ageRank(next) <= ageRank(current);
}

export interface ChatPolicy {
  /** Typing free text to the table. */
  freeChat: boolean;
  /** The quick phrases and the pings: for everybody, always. */
  quickPhrases: true;
}

/** What a player of this band may do in a conversation. Nobody who has not said stays on phrases. */
export function chatPolicy(group: AgeGroup | null): ChatPolicy {
  return { freeChat: group === '14_to_17' || group === '18_plus', quickPhrases: true };
}
